import React from "react";

function CautionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#FAAD14"
        d="M9 2a7 7 0 10.001 14.001A7 7 0 009 2zm-.5 3.625c0-.069.056-.125.125-.125h.75c.069 0 .125.056.125.125v4.25a.125.125 0 01-.125.125h-.75a.125.125 0 01-.125-.125v-4.25zM9 12.5A.75.75 0 019 11a.75.75 0 010 1.5z"
      ></path>
    </svg>
  );
}

export default CautionIcon;